import React, { Dispatch, SetStateAction, useContext, useState } from "react";

interface IUserEP {
  personCode: string;
  isDefault: boolean;
  fullName: string;
  name: string;
  departmentName: string;
  organizationName: string;
  employeeId: number;
  employeePositionId: number;
  employeePositionCode: "";
  sexKind: 1,
}

interface IAuthContext {
  userEmployeePosition: IUserEP;
  authenticatedHandler: boolean;
  userRoles: IUserEP[];
  setAuthenticatedHandler?: Dispatch<SetStateAction<boolean>>;
  setUserEmployeePosition?: Dispatch<SetStateAction<any>>;
  setUserRoles?: Dispatch<SetStateAction<any>>;
}

const initialValue: IAuthContext = {
  userEmployeePosition: {
    personCode: "",
    isDefault: false,
    fullName: "",
    name: "",
    departmentName: "",
    organizationName: "",
    employeeId: 0,
    employeePositionId: 0,
    employeePositionCode: "",
    sexKind: 1,
  },
  authenticatedHandler: false,
  userRoles: [],
};

const AuthContext = React.createContext({} as IAuthContext);

export const useAuth = () => {
  return useContext(AuthContext);
};

function AuthProvider(props: any) {
  const [authenticatedHandler, setAuthenticatedHandler] = useState(false);
  const [userEmployeePosition, setUserEmployeePosition] = useState<IUserEP>({
    personCode: "",
    isDefault: false,
    fullName: "",
    name: "",
    departmentName: "",
    organizationName: "",
    employeeId: 0,
    employeePositionId: 0,
    employeePositionCode: "",
    sexKind: 1,
  });
  const [userRoles, setUserRoles] = useState([]);

  return (
    <AuthContext.Provider
      value={{
        userEmployeePosition,
        authenticatedHandler,
        setAuthenticatedHandler,
        setUserEmployeePosition,
        userRoles,
        setUserRoles,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}

const AuthConsumer = AuthContext.Consumer;

export { AuthProvider, AuthConsumer };

export default AuthContext;
